/**
 * The destination, if it is one we may open at all.
 *
 * Not our policy — a copy of the check both `openLink` and `openTelegramLink`
 * apply to their own argument: anything but `http:` and `https:` makes them
 * throw `WebAppTgUrlInvalid`. So this pair is fixed by Telegram rather than a
 * list that grows as we meet new schemes. `tg:` in particular is a real scheme
 * and parses fine, but adding it here would turn a link that is safely inert
 * into one that throws on click.
 */
export const parseOpenableUrl = (raw: string): URL | null => {
  try {
    const url = new URL(raw)
    return url.protocol === "https:" || url.protocol === "http:" ? url : null
  } catch {
    return null
  }
}

/**
 * A copy of `isTmeHostname`, the second thing `openTelegramLink` insists on.
 *
 * Read off `hostname` rather than the raw string, which is what keeps
 * `https://t.me@evil.example/x` — a URL that reads as Telegram to a person —
 * out of a Telegram deep link.
 */
export const isTelegramHost = (url: URL): boolean => url.hostname === "t.me" || url.hostname === "telegram.me"

/**
 * Whether a caller asked for the link to be inert.
 *
 * `aria-disabled` arrives as a boolean or as the string "true" — React accepts
 * both — so a bare truthiness check would read the string "false" as disabled.
 */
export const isAriaDisabled = (value: React.AriaAttributes["aria-disabled"]): boolean =>
  value === true || value === "true"
